import { getCurrentUserAccessLevel } from "./getCurrentUseAccessLevel";

export function userHasAccess(subModuleName, minAccessLevel) {
  const userAccessLevel = getCurrentUserAccessLevel(subModuleName);
  if (userAccessLevel < minAccessLevel) {
    return false;
  } else {
    return true;
  }
}